module.exports = __webpack_public_path__ + "img/workout2.bdd94caa.jpg";